import styled from 'styled-components'

const HR = styled.hr`
  margin-top: 0;
`

export default HR
